import {useContext, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {containsXss} from "../../../utils/security/XssFilter";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import {IAM_SERVER_SERVICE, IAM_SERVER_AUTH_TOKEN_POLICY} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from '../../../utils/modal/DetailModal.module.css';
import { InnocodeButton } from "@intsoft/innocode-core";
import Switch from "@mui/material/Switch";


/**
 * 서비스스 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const ServiceRegisterModal = ({tenantId, update}) => {
    const {closeModal} = useContext(ModalContext);
    const [isNull, setIsNull] = useState(false); //빈 값 확인

    const [formData, setFormData] = useState({
        linkServiceId: '',
        linkServiceName: '',
        linkServiceDomain: '',
        refreshTokenTime: '',
        accessTokenTime: '',
        redirectUri: '',
        autoJoinEnabled: true,
    });

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    }

    const handleAutoJoinChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            autoJoinEnabled: e.target.checked
        }));
    }

    // 서비스스 등록 요청 API
    const handleRegister = () => {
        for (let key in formData) {
            if (typeof formData[key] === 'boolean') {
                continue;
            }
            if (formData[key] === '') {
                setIsNull(true);
                return;
            } else if (containsXss(formData[key])) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }))
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        setIsNull(false);
        
        const serviceParams = {
            serviceId: formData.linkServiceId,
            serviceName: formData.linkServiceName,
            serviceDomain: formData.linkServiceDomain,
            autoJoinEnabled: formData.autoJoinEnabled,
            createdBy: tenantId
        };
            
        const authTokenPolicyParams = {
            clientId: formData.linkServiceId,
            refreshTokenTime: formData.refreshTokenTime,
            accessTokenTime: formData.accessTokenTime,
            redirectUri: formData.redirectUri
        };

        const url = IAM_SERVER_SERVICE + "/create";
        axios.post(url, serviceParams)
            .then((res) => {
                const url = IAM_SERVER_AUTH_TOKEN_POLICY + "/create";
                axios.post(url, authTokenPolicyParams)
                    .then((res) => {
                        showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                        update();
                    })
                    .catch((e) => {
                        showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
                    });
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }

    const handleDuplicateCheck = () => {
        if (!formData.linkServiceId) {
            showDialog(DialogEnum.FAIL, "중복확인", "서비스 아이디를 입력해주세요.");
            return;
        }

        const url = IAM_SERVER_SERVICE + "/exists/"+formData.linkServiceId;
        axios.get(url)
            .then(res => {
                if (res.data.data) {

                    showDialog(DialogEnum.FAIL, "중복확인", "이미 사용 중인 아이디입니다.");
                } else {
                    showDialog(DialogEnum.SUCCESS, "중복확인", "사용 가능한 아이디입니다.");
                }
            })
            .catch(err => {
                console.error(err);
                showDialog(DialogEnum.FAIL, "중복확인", "오류가 발생했습니다.");
            });
    };

    return (
        <div>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>서비스 아이디</p>
                    <input className={styles.layer__listInput}
                           type={"text"}
                           name={"linkServiceId"}
                           value={formData.ilinkServiceIdd}
                           onChange={handleChange}/>
                           <InnocodeButton
                                type="button" 
                                onClick={handleDuplicateCheck}
                                backgroundColor="var(--status-negative, #f83a3a)"
                           > 
                           중복확인</InnocodeButton>
                    {/* <button
                        type="button"
                        className={styles.layer__listInput__duplicateCheckBtn}
                        onClick={handleDuplicateCheck}
                    >
                        중복확인
                    </button> */}
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>서비스 명</p>
                    <input className={styles.layer__listInput}
                           type={"text"}
                           name={"linkServiceName"}
                           value={formData.linkServiceName}
                           onChange={handleChange}/>
                </li>
                <li className={styles.layer__list}>
                    <p lang={"ko"} className={styles.layer__listTit}>서비스 도메인</p>
                    <input className={styles.layer__listInput}
                           type={"text"}
                           name={"linkServiceDomain"}
                           value={formData.linkServiceDomain}
                           onChange={handleChange}/>
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>자동가입</p>
                    <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                        <Switch
                            checked={formData.autoJoinEnabled}
                            onChange={handleAutoJoinChange}
                            color="primary"
                        />
                        <span style={{fontWeight: 600, color: formData.autoJoinEnabled ? '#2458e6' : '#777'}}>
                            {formData.autoJoinEnabled ? '허용' : '미허용'}
                        </span>
                    </div>
                </li>
            </ul>

            <div className={styles.layer__sensorBox}>
                        <p className={styles.layer__sensorTit}>정책설정</p>
                <ul className={styles.layer__listWrap}>
                    <li className={styles.layer__list}>
                        <p className={styles.layer__listTit}>토큰시간(s)</p>
                        <input className={styles.layer__listInput}
                            type={"number"}
                            name={"accessTokenTime"}
                            value={formData.accessTokenTime}
                            onChange={handleChange}/>
                    </li>
                    <li className={styles.layer__list}>
                        <p className={styles.layer__listTit}>리플래시 토큰시간(s)</p>
                        <input className={styles.layer__listInput}
                            type={"number"}
                            name={"refreshTokenTime"}
                            value={formData.refreshTokenTime}
                            onChange={handleChange}/>
                    </li>
                    <li className={styles.layer__list}>
                        <p className={styles.layer__listTit}>Redirect URL</p>
                        <input className={styles.layer__listInput}
                            type={"text"}
                            name={"redirectUri"}
                            value={formData.redirectUri}
                            onChange={handleChange}/>
                    </li>
                </ul>
            </div>



            {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
            {/* <button className={styles.layer__saveBtn} onClick={handleRegister}>등록</button> */}
            <div className={styles.layer__saveBtnBox}>  
                <InnocodeButton
                    size="md"
                    designType="primary" 
                    fullWidth={true}
                    className={styles.layer__saveBtn}
                    onClick={handleRegister}
                >등록</InnocodeButton>
            </div>
        </div>
    )
}
